export default {
  props: {
    validationState: { type: Object, required: true },
    validationMessages: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    validationFailures() {
      const vm = this;
      if (!vm.validationState.$dirty) {
        return [];
      }
      return vm.validationState
        .$flattenParams()
        .filter(param => vm.validationState[param.name] === false);
    }
  },
  methods: {
    validationMessage(param) {
      return (
        this.validationMessages[param.name] || "validations_field_" + param.name
      );
    }
  }
};
